import app from './feathers'
import { keyStore } from '../stores/keyStore'

const keyService = app.service('api-keys')

const methods = {
    async create(data) {
        const res = await keyService.create(data)
        keyStore.add(res)
        return res
    },
    async get() {
        const keys = await keyService.find()
        keyStore.set(keys.data)
        return keys
    },
    async update(key) {
        const res = await keyService.update(key._id, key)
        keyStore.update(res)
        return res
    },
    async remove(id) {
        const res = await keyService.remove(id)
        keyStore.remove(res._id)
        return res
    },
}

export default methods
